/* eslint-disable no-unused-vars */
/**
 * @typedef {Object} DisputeTimesheetDetailsCandidateCommentModelType
 * @property {ShiftRecordAddedComment} details
 * @property {Date} submittedDateUtc - Date timesheet was submitted
 * @property {TimesheetModificationsViewModel} modifications - List of modifications changing the original booking times
 * @property {boolean} shouldShowRestBreaksQuestion
 */

import TimesheetModificationsViewModel from './timesheetModificationsViewModel'
import ShiftRecordAddedComment from './shiftRecordAddedComment'
import DisputeTimesheetDetailsCandidate from './disputeTimesheetDetailsCandidate'

/**
 * @class
 */
export default class DisputeTimesheetDetailsCandidateCommentModel extends DisputeTimesheetDetailsCandidate {
  /**
   * Create a new DisputeTimesheetDetailsCandidateCommentModel.
   * @param {DisputeTimesheetDetailsCandidateCommentModelType} params
   */
  constructor(params) {
    super(params)
    this.shouldShowRestBreaksQuestion = params.shouldShowRestBreaksQuestion
  }
}
